<template>
  <div>
    <!-- 选择策略组 -->
    <el-dialog
      title="保存策略组"
      :visible.sync="dialogCreateModeVisible"
      width="50%"
      :modal="false">
      <el-form label-width="140px">
        <el-form-item label="已有策略组">
          <el-select
            v-model="selectMode"
            placeholder="更新已有渠道策略组"
            @change="({id, name}) => {
              modeId = id
              modeName = name
            }"
            value-key="id"
            clearable>
            <el-option
              v-for="item in policyList"
              :key="item.id"
              :label="item.name"
              :value="item">
            </el-option>
          </el-select>
          <span class="ml1" style="font-size: 12px; color: red;">不选为新建</span>
        </el-form-item>
        <el-form-item label="策略组名称" required>
          <el-input
            v-model="modeName"
            :disabled="Boolean(modeId)"
            placeholder="输入报表策略组名称"
            style="width: 220px;"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="dialogCreateModeVisible = false">取 消</el-button>
          <el-button type="primary" @click="createMode">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="策略组" :visible.sync="dialogTableVisible">
      <el-table :data="policyList">
        <el-table-column property="name" label="名称"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="120">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="getMode(scope.row.model_value)"
              type="text"
              size="small">
              选择
            </el-button>
            <el-button
              @click.native.prevent="delModel(scope.row)"
              type="text"
              size="small"
              style="color: red;">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import fetch from "@/assets/js/axios.js";

export default {
  name: 'commonMode',
  data() {
    return {
      // 策略组
      dialogTableVisible: false,
      policyList: [],
      modeName: '',
      modeId: null,
      selectMode: null,
      dialogCreateModeVisible: false,
    };
  },
  props: {
    searchValue: Object,
  },
  mounted() {
    this.getPolicyGroupList();
  },
  methods: {
    // 策略组
    getPolicyGroupList() {
      fetch({
        url: "/admin/package_statistics/get_create_model_List",
        method: "GET",
        params: {
          menus_name: 'common'
        }
      }).then((res) => {
        this.policyList = res.data.data.list.data
      })
    },
    getMode ({ game_id, channel_id, group_channel_ids, game_package_id  }) {
      this.dialogTableVisible = false
      this.$emit('getList', {
        channel_id
      })
    },
    async createMode () {
      const { channel_id  } = this.searchValue
      const data = {
        name: this.modeName,
        menus_name: 'common',
        model_value: {
          channel_id
        },
        type: 1
      }
      if (this.modeId) data['id'] = this.modeId
      fetch({
        url: "/admin/package_statistics/create_mode",
        method: "POST",
        data
      }).then((res) => {
        this.$message.success(`策略组：${this.modeName} 创建成功～`)
        this.dialogTableVisible = false
        this.dialogCreateModeVisible = false
        this.modeName = ''
        this.selectMode = null
        this.modeId = null
        this.getPolicyGroupList()
      })
    },
    delModel ({id, name}) {
      this.$confirm(`确定删除策略组:${name}吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        fetch({
          url: "/admin/package_statistics/del_mode",
          method: "POST",
          data:{ids: id}
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
          this.getPolicyGroupList()
        })
      })
    },
  },
}
</script>

<style lang="less" scoped>

</style>
